import React, { useCallback } from 'react';

import CampaignBanner from 'components/CampaignBanner';

import type { BannerContent, Location, Meta } from 'Campaign-Types';

export type BannerCampaignProps = {
  campaignData: BannerContent;
  campaignMeta?: Meta;
  location: Location;
  pageType: string;
  siteSection: string;
  pageName: string;
};

/**
 * Renders a campaign that displays inside a banner
 * @param campaignData - The data for the campaign.
 * @param campaignMeta - The meta data for the campaign.
 * @param location - The location where the campaign is rendered.
 * @param pageType - The type of the page where the campaign is rendered.
 * @param siteSection - The section of the site where the campaign is rendered.
 * @param pageName - The name of the page where the campaign is rendered.
 */
function BannerCampaign(props: BannerCampaignProps) {
  const { location, campaignData, pageType, siteSection, pageName } = props;
  const {
    url,
    imagePC,
    imageSP,
    title,
    text,
    ctaText,
    imageStylePC,
    queryParam = '',
  } = campaignData;
  const ratParams = {
    pageName: pageName + ':' + campaignData.pageName,
    siteSection,
    pageType,
    queryParam,
  };
  const hasButton = (['top_page', 'upcoming_reservation'] as Location[]).includes(location);
  const size = location === 'booking_step_3' ? 'medium' : 'default';
  return (
    <CampaignBanner
      hasButton={hasButton}
      url={url}
      imagePC={imagePC}
      imageSP={imageSP}
      title={title}
      subtitle={text}
      ctaText={ctaText}
      ratParams={ratParams}
      size={size}
      imageStylePC={imageStylePC}
    />
  );
}

export default BannerCampaign;
